import { MediumContent } from 'modules/graphql/types';
import { InsertSnippetModal } from 'modules/snippets/components/modals/InsertSnippetModal';
import { concatSnippetWithTextInput, MediumDataKey } from 'modules/templateEditor/common';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import {
  ContentModalStateType,
  InsertSnippetModalType,
  useModalContext,
} from 'utils/contexts/modal';

export const canInsertSnippet = (
  modalState: ContentModalStateType | null,
): modalState is InsertSnippetModalType =>
  !!modalState && 'mediumDataKey' in modalState && !!modalState.mediumDataKey.length;

export const TemplateInsertSnippetModal = () => {
  const { modalState, hideModal } = useModalContext<ContentModalStateType>();
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const mediumData = (liveTemplate?.mediumData || {}) as MediumContent;

  if (!canInsertSnippet(modalState)) return null;

  const handleInsertSnippet = (copiedSnippet: string) => {
    const { mediumDataKey, mediumDataValue, mediumRef } = modalState;
    const textWithSnippet = concatSnippetWithTextInput(copiedSnippet, mediumDataValue, mediumRef);

    /** Some mediumDataKey has nested keys. For ex: inboxMetadata.title */
    if (mediumDataKey.includes('.')) {
      const parentProp = mediumDataKey.split('.')[0] as MediumDataKey;
      const childProp = mediumDataKey.split('.')[1] as MediumDataKey;
      setCurrentMediumField(parentProp, {
        // @ts-ignore TS7053: Element implicitly has an 'any' type because expression of type 'MediumDataKey'
        // can't be used to index type 'MediumContent'. Property 'ampHtml' does not exist on type 'MediumContent'.
        ...mediumData[parentProp],
        [childProp]: textWithSnippet,
      });
    } else {
      setCurrentMediumField(mediumDataKey, textWithSnippet);
    }
  };

  return (
    <InsertSnippetModal
      closeModal={hideModal}
      onInsertSnippet={
        modalState.mediumDataKey !== 'cannotInsert' ? handleInsertSnippet : undefined
      }
    />
  );
};
